<template>
    <section id="carrousel">
        <slider animation="normal"
            width="100%"
            height="300px"
            :init-index="0"
            :auto="true"
            :interval="6000"
            >
            <slider-item>
                <div class="slide-background"><img  src="/static/img/carrousel/test1.png"/></div>
                <article>
                  <!-- <p>Aidant, venez-vous former sur <em>Savoir Être Aidant</em>, <br/>un site fait pour vous dans lequel vous trouverez informations et conseils.</p>-->
                  <p> Venez participer aux formations présentielles gratuitement </p>
                  <p><img @click="navigate('/events', false)" class="logo2" src="/static/img/voir-maintenant.png"/></p>
                </article>
            </slider-item>
            <slider-item>
                <div class="slide-background"><img src="/static/img/carrousel/test2.png"/></div>
                <article>
                  <p>Inscrivez-vous pour avoir accès à du contenu supplémentaire.</p>
                   <!--<p><a v-scroll-to="'#mainContainer'"><img class="logo2" src="/static/img/inscrire.png"/></a></p>-->
                   <p><img @click="navigate('/register', false)" class="logo2"  src="/static/img/inscrire.png"/></p>
                </article>
            </slider-item>
            <slider-item>
                <div class="slide-background"><img src="/static/img/carrousel/test3.png"/></div>
                <article>
                   <p>Aidants, qui sont-ils ?</p>
                    <!--<p><router-link to="/register"></router-link>-->
                    <p><img @click="navigate('/roles-des-aidants', true)" class="logo2" src="/static/img/voir-maintenant.png"/></p>
                </article>
            </slider-item>
            <slider-item>
                <div class="slide-background"><img src="/static/img/carrousel/test4.png"/></div>
                <article>
                   <p>Comprendre le vieillissement</p>
                    <!--<p><router-link to="/register">-->
                    <p><img @click="navigate('/roles-des-aidants', true)" class="logo2" src="/static/img/voir-maintenant.png"/></p>
                </article>
            </slider-item>
            <slider-item>
                <div class="slide-background"><img src="/static/img/carrousel/test5.png"/></div>
                <article>
                    <p>Le rôle des Aidants</p>
                    <p><img @click="navigate('/roles-des-aidants', true)" class="logo2"  src="/static/img/voir-maintenant.png"/></p>
                </article>
            </slider-item>
        </slider>
        <!--<svg width="300" height="300" class="carrousel-mask-left">
            <polygon points="0,300 0,130 293,300" style="fill:rgb(102,36,131);" />
            <polygon points="0,0 0,170 293,0" style="fill:rgb(0,159,227);" />
        </svg>
        <svg width="300" height="300" class="carrousel-mask-right">
            <polygon points="300,130 0,300 300,300" style="fill:rgb(0,86,155);" />
        </svg>-->
    </section>
</template>
<script>
import { Slider, SliderItem } from 'vue-easy-slider'
    export default {
        data: function () {
            return {
                slides: [
                    { text: ""}
                ]
            }
        },
        components: {
            Slider,
            SliderItem
        },
        methods: {
            navigate: function(path, isCategory) {
                this.$emit('navigate', { path: path, isCategory: isCategory });
            }
        }
    }
</script>
<style>

.slider button:focus 
{
    outline:none;
}
.slider button:hover
{
    transform:scale(1.2) ;
}
.slider button:active
{
    outline:none;
    transform:scale(0.8) ;
}
.slide-background
{
    z-index: -500;
    position: absolute;
    text-align: center;
    top:0px;
    opacity:1;
    margin:auto;
    width:100%;
    /*background:red;*/
}
.slide-background img
{
    height:304px;
    width:auto;
}
.slider
{
    margin-top:20px;
    /*padding:0px 10% 0px 10%;*/
}
#carrousel .slider .btn
{
   background: url("/static/img/carrousel/right-arrow-button.png") no-repeat;
    /*transform: scaleX(-1);*/
}
#carrousel .slider .btn-left
{
    left:10%;
}
#carrousel .slider .btn-right
{
    right:10%;
}

/*#carrousel .slider-icon
{
    border-left: 2px solid black;
    border-bottom: 2px solid black;
}*/
#carrousel
{
    max-width:100%;
    /*border:red 2px solid;*/
    position :absolute;
}
#carrousel div:first-child
{
    margin:auto;
}
#carrousel p
 {
    text-align:justify;
    margin:auto;
    margin-bottom:0px;
    max-width: 80%;
    width:auto;
    color: #ffffff;
    font-family: 'andes_boldbold', Arial, sans-serif;
    font-size:2.5em;
    /*margin-right: 30px;*/
 }
#carrousel article
{
    padding:50px;
    display: flex;
    flex-direction: column;
    justify-content:center;
    align-content:center;
    align-items:center;
    margin:auto;
    position:relative;    
}
#carrousel img.logo
{
    width: auto; 
    max-height:150px;
}
#carrousel img.logo:hover {
    transform: translateX(5px) scale(1.1);
    cursor: pointer;
  }
#carrousel img.logo2
{
    width: auto; 
    margin-top:45px;
    max-height:150px;
    transition: 0.5s;
}
#carrousel img.logo2:hover {
    transform: translateX(5px) scale(1.1);
    cursor: pointer;
    transition: 0.5s;
  }
.carrousel-mask-left
{
        position :absolute;
        z-index:200;
        top:0px;
        left:0px;
}
.carrousel-mask-right
{
        position :absolute;
        z-index:200;
        top:0px;
        right:0px;
}
</style>



// WEBPACK FOOTER //
// Carrousel.vue?b3714374